module.exports = __webpack_public_path__ + "img/weibo.b03faa62.svg";